import type { SearchFilterTypeMap } from './types';

export const brandListFallback = [
  'Aion',
  'Alfa Romeo',
  'Alpine',
  'Aston Martin',
  'Audi',
  'BAC',
  'Bentley',
  'BMW',
  'BMW ALPINA',
  'BYD',
  'Chevrolet',
  'Citroen',
  'DFSK',
  'Farizon',
  'Ferrari',
  'Ford',
  'Foton',
  'Golden Dragon',
  'Higer',
  'Hino',
  'Honda',
  'Hyundai',
  'Isuzu',
  'Jaguar',
  'Jeep',
  'Kia',
  'KYC',
  'Lamborghini',
  'Land Rover',
  'LEVC',
  'Lexus',
  'Lotus',
  'Maserati',
  'Maxus',
  'Mazda',
  'McLaren',
  'Mercedes-Benz',
  'MG',
  'MINI',
  'Mitsubishi',
  'Mitsuoka',
  'Morgan',
  'Nissan',
  'OHM',
  'Omoda',
  'Opel',
  'ORA',
  'Pagani',
  'Perodua',
  'Peugeot',
  'Polestar',
  'Porsche',
  'Renault',
  'Rolls-Royce',
  'Seres',
  'Skoda',
  'smart',
  'SOKON',
  'SRM',
  'SsangYong',
  'Subaru',
  'Suzuki',
  'Tesla',
  'Toyota',
  'Volkswagen',
  'Volvo',
  'XPENG',
  'Yutong',
  'ZEEKR',
];

export const createEyeotaAJSScriptTargetMapping = (
  query: SearchFilterTypeMap,
) => {
  const result = {
    cat: [
      'newcarintent',
    ],
  };

  if (query.make) {
    result.cat.push(`new${query.make.toLowerCase().replace(/[-\s]/g, '')}`);
  }

  if (query.vehicleType) {
    result.cat.push(`new${query.vehicleType.toLowerCase() === 'sports' ? 'sportscar' : query.vehicleType.toLowerCase()}`);
  }

  if (query.category) {
    result.cat.push(`newcat${query.category}`);
  }

  if (query.transmission) {
    result.cat.push(`newtrans${query.transmission === 'A' ? 'auto' : 'manual'}`);
  }

  if (query.fuelType) {
    result.cat.push(`new${query.fuelType.replace(/[-\s]/g, '')}`);
  }

  const getPriceCategory = (price: number): string => {
    if (price < 100000) return 'newpricebelow100k';
    if (price < 150000) return 'newprice100kto150k';
    if (price < 200000) return 'newprice150kto200k';
    if (price < 250000) return 'newprice200kto250k';
    if (price < 300000) return 'newprice250kto300k';
    if (price < 350000) return 'newprice300kto350k';
    if (price < 400000) return 'newprice350kto400k';
    if (price < 500000) return 'newprice400kto500k';
    return 'newpriceabove500k';
  };

  if (query.minPrice) {
    result.cat.push(getPriceCategory(query.minPrice));
  } else if (query.maxPrice) {
    result.cat.push(getPriceCategory(query.maxPrice));
  }

  if (query.maxEngineCapacity === 661) {
    result.cat.push('newbelow661cc');
  } else if (query.minEngineCapacity === 661
  && query.maxEngineCapacity === 1600) {
    result.cat.push('new661ccto1600cc');
  } else if (query.minEngineCapacity === 1601
  && query.maxEngineCapacity === 2000) {
    result.cat.push('new1601ccto2000cc');
  } else if (query.minEngineCapacity === 2001
  && query.maxEngineCapacity === 3000) {
    result.cat.push('new2001ccto3000cc');
  } else if (query.minEngineCapacity === 3000) {
    result.cat.push('newabove3000cc');
  }

  return result;
};
